import { useEffect, useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useApiEffect, usePlaces } from '~/hooks';
import { getGlobalRoute } from '~/services/routes';
import NSearch from '../NSearch';
import {
  AppHomeHeaderContainer,
  CategoriesContainer,
  CategoryContainer,
  DecreasePassengersQTDButton,
  HeaderMid,
  HeaderTop,
  IncreasePassengersQTDButton,
  PassengerDriverSelect,
  SelectAdressContainer,
  SelectedPassengerNumberDiv,
  SelectPassengersQTDContainer,
} from './styles';

export default function AppHomeHeader({
  selectedCategory,
  setSelectedCategory,
  selectedPassengersQTD,
  categories,
  updatePassengersQTD,
  setDisembarkationData,
  setEmbarkationData,
  onSearch,
  setSelectedUser,
  selectedUser,
}) {
  const [globalRoute, setGlobalRoute] = useState();
  const [disembarkationLocal, setDisembarkationLocal] = useState(null);
  const [embarkationInfo, setEmbarkationInfo] = useState();

  const [focusedInput, setFocusedInput] = useState(null);

  useApiEffect(getGlobalRoute, response => {
    setGlobalRoute(response.data.content[0]);
  });

  const { searchRef: embarkationRef } = usePlaces(
    globalRoute?.boardingDistrict?.id,
    true,
    'TRIPS',
    embarkationData => {
      setEmbarkationData(embarkationData);
      setEmbarkationInfo(prev => ({
        ...prev,
        data: embarkationData,
      }));
    },
    city => {
      setEmbarkationInfo(prev => ({
        ...prev,
        city,
      }));
    }
  );

  const { searchRef: disembarkationRef } = usePlaces(
    '177c6210-9033-43bf-94dd-7b5fcc78ffd3',
    false,
    'TRIPS',
    disembarkationData => {
      setDisembarkationData(disembarkationData);
      setDisembarkationLocal(disembarkationData);
    }
  );

  useEffect(() => {
    if (
      embarkationInfo?.data?.latitude &&
      embarkationInfo?.data?.longitude &&
      embarkationInfo?.city
    ) {
      onSearch(
        embarkationInfo.data,
        disembarkationLocal,
        null,
        embarkationInfo.city
      );
    }
  }, [embarkationInfo, disembarkationLocal]);

  useEffect(() => {
    const pacContainers = document.querySelectorAll('.pac-container');
    pacContainers.forEach(container => {
      if (focusedInput === 'nsearch') {
        container.style.zIndex = 25;
      } else if (focusedInput === 'nsearch2') {
        container.style.zIndex = 16;
      } else {
        container.style.zIndex = 10;
      }
    });
  }, [focusedInput]);

  return (
    <AppHomeHeaderContainer selectedUser={selectedUser}>
      <HeaderTop>
        <img src="/images/relep_logo.png" alt="Icon" />
        <PassengerDriverSelect
          onChange={e => {
            setSelectedUser(e.target.value);
            onSearch(
              embarkationInfo.data,
              disembarkationLocal,
              null,
              embarkationInfo.city,
              null
            );
          }}
        >
          <option value="PASSENGER">Sou passageiro</option>
          <option value="DRIVER">Sou motorista</option>
        </PassengerDriverSelect>
      </HeaderTop>

      <HeaderMid selectedUser={selectedUser}>
        <SelectPassengersQTDContainer>
          <IncreasePassengersQTDButton
            onClick={() => {
              updatePassengersQTD(true, embarkationInfo, disembarkationLocal);
            }}
          >
            <FaPlus color="#FF4406" size={30} />
          </IncreasePassengersQTDButton>
          <SelectedPassengerNumberDiv>
            {selectedPassengersQTD}
          </SelectedPassengerNumberDiv>
          <DecreasePassengersQTDButton
            onClick={() => {
              updatePassengersQTD(false, embarkationInfo, disembarkationLocal);
            }}
          >
            <FaMinus color="#FF4406" size={30} />
          </DecreasePassengersQTDButton>
        </SelectPassengersQTDContainer>

        <SelectAdressContainer>
          <NSearch
            ref={embarkationRef}
            className="nsearch"
            placeholder="Digite o nome da rua:"
            onFocus={() => setFocusedInput('nsearch')}
            onBlur={() => setFocusedInput(null)}
          />
          <NSearch
            ref={disembarkationRef}
            className="nsearch2"
            placeholder="Digite o nome da rua:"
            onFocus={() => setFocusedInput('nsearch2')}
            onBlur={() => setFocusedInput(null)}
          />
        </SelectAdressContainer>
      </HeaderMid>

      <CategoriesContainer selectedUser={selectedUser}>
        {categories.map(category => (
          <CategoryContainer
            key={category.value}
            isSelected={selectedCategory.value === category.value}
            onClick={() => {
              setSelectedCategory(category);
              onSearch(
                embarkationInfo?.data,
                disembarkationLocal,
                category.name,
                embarkationInfo?.city,
                null
              );
            }}
          >
            {category.name}
          </CategoryContainer>
        ))}
      </CategoriesContainer>
    </AppHomeHeaderContainer>
  );
}
